import { render, staticRenderFns } from "./classinfolist.vue?vue&type=template&id=b823381e&scoped=true"
import script from "./classinfolist.vue?vue&type=script&lang=js"
export * from "./classinfolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b823381e",
  null
  
)

export default component.exports